<template>
 <Breadcrumb page-title="Search Interactions" page-section="Pages"> </Breadcrumb>
  <section class="content">
    <SearchInteractions></SearchInteractions>
  </section>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '../components/Breadcrumb.vue';
import SearchInteractions from '../components/SearchInteractions.vue';

export default {
  name: 'Contact',
  components: {
    Breadcrumb,
    SearchInteractions
  },
  ready () {
    $(document).ready(function ($) {
    })
  }
}
</script>